import { AllocationString } from '../allocation-info/allocation-string-modal/allocation-string';

export class SaveAllocationStringDto extends AllocationString {
  allocation_info_row_id: number;
  line_item_row_id: number;
  amount_val: number;
  amount_ind: string;
}
